import Cookies from 'universal-cookie'
import moment from 'moment'

import Client from './Client'
import api from './index'

const TOKEN_NAME = 'token'

class Persister {
  constructor() {
    this.cookie = new Cookies()
  }

  save(key, value) {
    const maxAge = moment.duration(2, 'weeks')
    this.cookie.set(key, value, {
      path: '/',
      expires: moment()
        .add(maxAge)
        .toDate(),
      maxAge: maxAge.asSeconds(),
      secure: process.env.NODE_ENV !== 'development',
    })
  }

  load(key) {
    return this.cookie.get(key) || null
  }

  remove(key) {
    this.cookie.remove(key)
  }

  isSupported() {
    return true
  }
}

function parseCredentials(credentials) {
  return {
    accessToken: credentials.access_token,
    expiresIn: credentials.expires_in,
    tokenType: credentials.token_type,
    scope: credentials.scope,
    refreshToken: credentials.refresh_token,
  }
}

export default class Token {
  credentials
  client

  constructor(client: Client) {
    this.client = client
    this.persister = new Persister()
    this.load()
  }

  save(): void {
    this.persister.save(TOKEN_NAME, this.credentials)
  }

  load(): void {
    this.credentials = this.persister.load(TOKEN_NAME)
  }

  async get(username, password) {
    const response = await api.auth.getToken(username, password)
    // TODO: Follow the DRY principle and extract both this promise
    // handler and the one below into a separate method.
    if (response.errors != null) {
      throw new Error("Couldn't refresh the token.")
    } else {
      const credentials = parseCredentials(response.data)
      this.credentials = credentials
      this.save()
      return credentials
    }
  }

  getFromAuthResponse(authResponse) {
    const credentials = parseCredentials(authResponse);
    this.credentials = credentials;
    this.save();
    return credentials;
  }

  async refreshToken() {
    if (this.credentials == null) {
      throw new Error('Not authenicated.')
    }
    const response = await api.auth.refreshToken()
    if (response.errors) {
      throw new Error("Couldn't refresh the token.")
    } else {
      const credentials = parseCredentials(response.data)
      this.credentials = credentials
      this.save()
      return credentials
    }
  }

  headers() {
    if (this.credentials != null) {
      const { tokenType, accessToken } = this.credentials
      return {
        Authorization: `${tokenType} ${accessToken}`,
      }
    }
    return {}
  }

  async revoke() {
    const { accessToken } = this.credentials
    await api.auth.revokeToken(accessToken)
    this.clear()
  }

  clear() {
    this.credentials = null
    this.persister.remove(TOKEN_NAME)
  }
}



// WEBPACK FOOTER //
// ../source/api/Token.js